import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { aiAssistantFields } from '../../fields/ai/ai-assistant.fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	aiAssistantFields.get('enabled'),
	aiAssistantFields.get('assistant_areas'),
	aiAssistantFields.get('max_tokens'),
	aiAssistantFields.get('budget_duration'),
	aiAssistantFields.get('conversation_retention_days'),
	aiAssistantFields.get('scenario')
];

const aiAssistantForm: IFormConfig = {
	editTitle: 'Modifica Assistente AI',
	fields: formFields
};

export default aiAssistantForm;
